import { render, staticRenderFns } from "./ExamCode.vue?vue&type=template&id=87ac387c&"
import script from "./ExamCode.vue?vue&type=script&lang=js&"
export * from "./ExamCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports